import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle
} from "@/components/ui/card";
import { useAuth } from "@/hooks/use-auth";
import { tailwind } from "@/utilities/tailwind-utils";

export default function Unauthorized() {
  const { userInfo, logoutAndRedirect } = useAuth();
  const navigate = useNavigate();

  const handleLogout = useCallback(async () => {
    try {
      await logoutAndRedirect();
    } catch (error) {
      console.error("Logout failed:", error);
      // Fallback: redirect to logout page
      navigate("/logout");
    }
  }, [logoutAndRedirect, navigate]);

  return (
    <div
      className={
        tailwind.layout.wrapperCenter + " " + tailwind.backgrounds.bgBackground
      }
    >
      <div className={tailwind.layout.flexColGap6}>
        <div
          className={
            tailwind.layout.flexCenter +
            " " +
            tailwind.sizes.size8 +
            " " +
            tailwind.borders.roundedFull +
            " " +
            tailwind.backgrounds.bgDestructive +
            "/10 mx-auto mb-4"
          }
        >
          <AlertTriangle className={tailwind.sizes.size5} />
        </div>
        <CardHeader className={tailwind.typography.textCenter}>
          <CardTitle>Access Denied</CardTitle>
          <CardDescription>
            You don't have permission to access this resource
          </CardDescription>
        </CardHeader>
        <CardContent className={tailwind.layout.flexColGap4}>
          {userInfo && (
            <div className={tailwind.typography.textSmMuted}>
              <p>Signed in as: {userInfo.name}</p>
              <p>Email: {userInfo.email || "Not available"}</p>
            </div>
          )}
          <div className={tailwind.layout.flexColGap2}>
            <Button onClick={() => navigate("/")} variant="outline">
              Go to Dashboard
            </Button>
            <Button onClick={handleLogout} variant="destructive">
              <LogOut className={tailwind.sizes.size4 + " mr-2"} />
              Sign Out
            </Button>
          </div>
        </CardContent>
      </div>
    </div>
  );
}
